export default __webpack_public_path__ + "static/media/warehousing-not-selected.1db4cde4.png";